import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";


export const searchByRouteAPI = async (from, to, date = null) => {
  return await axios.get(`${API_BASE_URL}/search/`, {
    params: {
      from_stop: from,
      to_stop: to,
      date: date,
    },
  });
};


export const searchByStopAPI = async (stop, date = null) => {
  return await axios.get(`${API_BASE_URL}/search_by_stop/`, {
    params: {
      stop: stop,
      date: date,
    },
  });
};


export const getTripTimetableAPI = async (tripId) => {
  return await axios.get(`${API_BASE_URL}/trips/${tripId}/timetable/`);
};

export const getStopsAPI = async () => {
  return await axios.get(`${API_BASE_URL}/stops/`);
};